import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=024e661c&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=024e661c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024e661c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('024e661c')) {
      api.createRecord('024e661c', component.options)
    } else {
      api.reload('024e661c', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=024e661c&scoped=true&", function () {
      api.rerender('024e661c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JEOI2ILSftNn/JS/comp/PopupDialog.vue"
export default component.exports